export const merchantGetters = {
  currentMerchantItems: (state) => state.currentMerchantItems,
  currentMerchant: (state) => state.currentMerchant,
  currentMerchantObject: (state) => state.currentMerchantObject,
  companyTypeGroups: (state) => state.companyTypeGroups,
  merchantInformation: (state) => state.merchantInformation,
  merchantStatusList: state => state.merchantStatusList,
  merchantIsManufacturer: state => state.merchantIsManufacturer
};